import React from 'react'
import { chatPermissions } from '@ztechapps/chat.common'
import { useRole } from '@ztechapps/common.hook'
import { BusyButtonLink } from '@ztechapps/webui.button'
import { useAssignChatToMe } from './useAssignChatToMe'

// The whole Assignee cell of an unassigned conversation, in the details panel and the inbox row. The panel's
// empty content lives inside the inline editor's click area, so the click stops here instead of also opening
// the picker. The inbox row also carries select and navigate handlers, so both click and double click stop here.
export const AssignToMeLink = ({ chatId }: { chatId: string }) => {
  const { hasRole: canEdit } = useRole({ roleName: chatPermissions.canEdit.value })
  const [assignChatToMe, { loading }] = useAssignChatToMe()

  return (
    <span onClick={(event) => event.stopPropagation()} onDoubleClick={(event) => event.stopPropagation()}>
      <BusyButtonLink
        bsSize="sm"
        text="Assign to me"
        icon="user-check"
        busyText="Assigning..."
        isBusy={loading}
        disabledReason={canEdit ? undefined : 'You need the Conversation edit permission to assign conversations.'}
        onClick={() => assignChatToMe(chatId)}
      />
    </span>
  )
}
